export const FETCH_TOURS_AGGREGATE = 'FETCH_TOURS_AGGREGATE';
export const FETCH_TOURS_AGGREGATE_INIT = 'FETCH_TOURS_AGGREGATE_INIT';
export const FETCH_TOURS_AGGREGATE_SUCCESS = 'FETCH_TOURS_AGGREGATE_SUCCESS';
export const FETCH_SALE_OPTIONS_INIT = 'FETCH_SALE_OPTIONS_INIT';
export const FETCH_SALE_OPTIONS_SUCCESS = 'FETCH_SALE_OPTIONS_SUCCESS';
